/* assets/article-content-enhance.js
 * Itération 2026-05-05 Batch 4 — Page article EDJ
 *
 * Auto-application de classes design system sur le contenu article rédigé en HTML
 * standard, pour que Guillaume n'ait pas à éditer le mode HTML pour chaque liste.
 *
 * Comportement :
 *   - Détecte les <ol> précédés (frères ou ancêtres-frères) d'un <h2>/<h3> contenant
 *     un mot-clé "étapes" / "etapes" / "phases" / "steps"
 *   - Ajoute la classe .edj-steps au <ol> détecté
 *   - Opt-out : si le <ol> a déjà la classe .edj-no-step-style, on ne fait rien
 *
 * Cible : .edj-article-content (wrapper du body article)
 *
 * Surcharge manuelle (Guillaume) :
 *   - Pour FORCER le style étapes :   <ol class="edj-steps">
 *   - Pour BLOQUER le style étapes :  <ol class="edj-no-step-style">
 */
(function () {
  'use strict';

  var KEYWORDS = ['étape', 'etape', 'phase', 'step'];

  function hasKeyword(text) {
    if (!text) return false;
    var lower = text.toLowerCase();
    for (var i = 0; i < KEYWORDS.length; i++) {
      if (lower.indexOf(KEYWORDS[i]) !== -1) return true;
    }
    return false;
  }

  /** Cherche le heading le plus proche AVANT cet <ol> (en remontant les frères, puis les frères du parent). */
  function findPrecedingHeading(olEl) {
    // 1) frères directs
    var sib = olEl.previousElementSibling;
    while (sib) {
      if (/^H[1-6]$/.test(sib.tagName)) return sib;
      // si on tombe sur du contenu lourd qui n'est pas un heading, on continue
      sib = sib.previousElementSibling;
    }
    // 2) si parent est wrapper (.edj-section, <div>...), on remonte d'un cran
    var parent = olEl.parentElement;
    if (parent && parent !== document.body) {
      var pSib = parent.previousElementSibling;
      while (pSib) {
        if (/^H[1-6]$/.test(pSib.tagName)) return pSib;
        // Cas : .edj-section qui WRAP un .edj-section-title
        var nestedH = pSib.querySelector ? pSib.querySelector('h1, h2, h3, h4, h5, h6, .edj-section-title') : null;
        if (nestedH) return nestedH;
        pSib = pSib.previousElementSibling;
      }
    }
    return null;
  }

  function enhance(root) {
    if (!root) return;
    var ols = root.querySelectorAll('ol');
    for (var i = 0; i < ols.length; i++) {
      var ol = ols[i];
      if (ol.classList.contains('edj-steps')) continue;       // déjà appliqué
      if (ol.classList.contains('edj-no-step-style')) continue; // opt-out
      var heading = findPrecedingHeading(ol);
      if (heading && hasKeyword(heading.textContent || '')) {
        ol.classList.add('edj-steps');
      }
    }
  }

  function init() {
    var roots = document.querySelectorAll('.edj-article-content');
    for (var i = 0; i < roots.length; i++) enhance(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
